import React, {useRef} from "react";
import {createUseStyles} from "react-jss";
import {useDimensionObserver} from "engage-client/hooks/useDimensionObserver";

const useStyles = createUseStyles({
	verticalBox: {
		width: props => `${props.width}px`,
		height: "100%",
		overflowY: "hidden"
	}
});

export type VerticalBoxConnectorProps = {
	width:number
	connectionPointY:number
}

export default function VerticalBoxConnector({width, connectionPointY}:VerticalBoxConnectorProps) {
	const containerRef = useRef(null);
	const {height=0} = useDimensionObserver(containerRef);
	const classes = useStyles({width});

	return (
		<div className={classes.verticalBox} ref={containerRef}>
			<svg height="100%" width={width} overflow="visible">
				<line x1={14} y1={connectionPointY + 10} x2={14} y2={height} stroke={"white"} strokeWidth={1} opacity={0.34} />
				<line x1={20} y1={connectionPointY - 40} x2={20} y2={height} stroke={"white"} strokeWidth={2} opacity={0.50} />
				<line x1={0} y1={connectionPointY} x2={width-8} y2={connectionPointY} stroke={"white"} strokeWidth={2} opacity={0.50} />
				<circle cx={width-4} cy={connectionPointY} r={4} fill={"white"} opacity={0.5}/>
			</svg>
		</div>

	);
}